var m = require('mithril');
var prop = require('mithril/stream');
var key = require('../libs/keybindings');
var Model = require('../libs/Model');
var modal = require('../layout/components/modal');
var serviceModel = require('./models/service');
var flash = require('../components/flash');

var addServiceClassModal = Object.assign(Object.create(Model), require('../../../../models/service/serviceClass'));
addServiceClassModal.originalName = '';

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});

function showRenameWarning(oldName, newName, confirmRename) {
  key.unbind('enter');
  key.setScope('modal');
  key('enter', 'modal', confirmRename);

  modal.vm.title(`Rename ${oldName} to ${newName}?`);
  modal.vm.body = function () {
    return m('div', [
      m('p', 'Warning, changing a class name can impact dashboards, diagrams, plugins, and integrations configured for that class. Manual updates may be necessary following this operation.')
    ]);
  };
  modal.vm.buttons([
    {
      label: 'Cancel',
      class: 'dib mr2',
      func: function () {
        key.unbind('enter');
        modal.vm.close();
      }
    },
    {
      label: 'Rename',
      class: 'dib red',
      func: confirmRename
    }
  ]);

  modal.vm.open();
}

addServiceClassModal.editDialogue = function (record, parentRecord, options) {
  Model.initForm.call(addServiceClassModal, record);
  addServiceClassModal.record = record;
  addServiceClassModal.originalName = record && record.name ? record.name : '';
  addServiceClassModal.form.parent(parentRecord ? parentRecord.name : '');
  addServiceClassModal.form.color(record && record.data ? record.data.color : '');
  addServiceClassModal.form.dashPattern(record && record.data ? record.data.dashPattern : '');

  var submit = function (skipRenameWarning) {
    var className = (addServiceClassModal.form.name() || '').trim();
    if (!className) {
      addServiceClassModal.errors = ['Name is required'];
      return;
    }
    if (!/^[A-Za-z0-9_]+$/.test(className)) {
      addServiceClassModal.errors = ['Name must use letters, numbers, or underscores only'];
      return;
    }

    if(addServiceClassModal.form.color() && isValidHexColor(addServiceClassModal.form.color())) {
      let body = {
        name: className,
        data: {
          color: addServiceClassModal.form.color(),
          dashPattern: addServiceClassModal.form.dashPattern()
        }
      };
      if (parentRecord) {
        body.parent = parentRecord.name;
      }
      let saveFlow = Promise.resolve();
      if (addServiceClassModal.record && addServiceClassModal.originalName && className !== addServiceClassModal.originalName) {
        if (!skipRenameWarning) {
          return showRenameWarning(addServiceClassModal.originalName, className, function () {
            modal.vm.close();
            submit(true);
          });
        }
        saveFlow = serviceModel.renameClass(addServiceClassModal.originalName, className);
      }
      saveFlow
        .then(() => serviceModel.saveChildrenClassData(body))
        .then(() => {
          addServiceClassModal.errors = [];
          key.unbind('enter');
          options && options.submitCallback ? options.submitCallback() : '';
          modal.vm.close();
          m.redraw();
        })
        .catch(error => {
          addServiceClassModal.errors = [error && (error.error || error.message) ? (error.error || error.message) : 'Unable to save service class'];
          m.redraw();
        });
    } else {
      if (addServiceClassModal.errors.indexOf('Invalid Hex Color.') == -1) {
        addServiceClassModal.errors.push('Invalid Hex Color.');
      }
    }
  };

  key.setScope('modal');
  key('enter', 'modal', submit);

  modal.vm.title(addServiceClassModal.record ? 'Edit Service Class: ' : 'Add Service Class: ');
  modal.vm.body = addServiceClassModal.view;

  modal.vm.buttons([
    {
      label: 'Save',
      class: 'btn-good',
      func: submit
    }
  ]);

  modal.vm.open();
};

addServiceClassModal.view = function () {
  return m('form', {role:'form'}, [
    m(flash, {items: addServiceClassModal.errors, bg: 'bg-red'}),
    m('label', 'Name:'),
    m('input.form-control.mb2', {
      type:'text',
      oninput: (ev) => addServiceClassModal.form.name(ev.target.value),
      value: addServiceClassModal.form.name(),
    }),
    m('label', 'Hex Color Code:'),
    m('dix.flex.items-center', [
      m('input.form-control', {
        type:'text',
        oninput: function(ev) {
          addServiceClassModal.form.color(ev.target.value);
          if (isValidHexColor(addServiceClassModal.form.color())) {
            updateColorPreview();
          }
        },
        value: addServiceClassModal.form.color(),
      }),
      m('div.h1.w1.ml2', {
        id: 'color-preview',
        style: {
          visibility: addServiceClassModal.form.color() && isValidHexColor(addServiceClassModal.form.color()) ? 'display' : 'hidden'
        },
        oncreate: updateColorPreview
      }),
    ]),
    m('label', 'Dash Pattern:'),
    m('input.form-control', {
      id:'name-input',
      type:'text',
      oninput: function(ev) {
        addServiceClassModal.form.dashPattern(ev.target.value);
      },
      value: addServiceClassModal.form.dashPattern(),
    }),
  ]);
};

function isValidHexColor(hex) {
  return /^#([0-9A-F]{3}){1,2}$/i.test(hex);
}

function updateColorPreview() {
  var previewDiv = document.getElementById('color-preview');
  if (previewDiv) {
      previewDiv.style.backgroundColor = addServiceClassModal.form.color();
      previewDiv.style.visibility = 'visible';
  }
}

module.exports = addServiceClassModal;
